/* istanbul ignore file */

// eslint-disable-next-line @cbhq/ts-no-enum
export enum NodeEnv {
  production = 'production',
  development = 'development',
  test = 'test',
}

// eslint-disable-next-line @cbhq/ts-no-enum
export enum ReleaseStage {
  production = 'production',
  development = 'development',
  local = 'local',
  test = 'test',
}

// Node Environments
const nodeEnv = process.env.NODE_ENV as NodeEnv;
const isDevelopmentNodeEnv = nodeEnv === NodeEnv.development;
const isProductionNodeEnv = nodeEnv === NodeEnv.production;
const isTestNodeEnv = nodeEnv === NodeEnv.test;

// Release Stages
export const releaseStage = process.env.RELEASE_STAGE as ReleaseStage;
export const isProductionRelease = releaseStage === ReleaseStage.production;
export const isDevelopmentRelease = releaseStage === ReleaseStage.development;
export const isTestRelease = releaseStage === ReleaseStage.test;

// Environments
export const isProductionDevelopment = isProductionNodeEnv;
export const isLocalDevelopment = isDevelopmentNodeEnv;
export const isTestEnvironment = isTestNodeEnv || isTestRelease;
export const isClient = typeof window !== 'undefined';

export const AMPLITUDE_API_KEY = process.env.AMPLITUDE_API_KEY ?? '';
export const ANALYTICS_DEBUG_LOGGING = process.env.ANALYTICS_DEBUG_LOGGING ?? 'disabled';
export const APP_VERSION = process.env.APP_VERSION ?? 'local';
export const RELEASE_STAGE = process.env.RELEASE_STAGE ?? 'local';
export const BUGSNAG_API_KEY = process.env.BUGSNAG_API_KEY ?? '';
export const BUGSNAG_NOTIFY_ENDPOINT = process.env.BUGSNAG_NOTIFY_ENDPOINT ?? '';
export const BUGSNAG_SESSION_ENDPOINT = process.env.BUGSNAG_SESSION_ENDPOINT ?? '';
export const BUGSNAG_SOURCEMAP_ENDPOINT = process.env.BUGSNAG_SOURCEMAP_ENDPOINT ?? '';
export const BUGSNAG_BUILD_ENDPOINT = process.env.BUGSNAG_BUILD_ENDPOINT ?? '';
